import { render, staticRenderFns } from "./GroupDropdown.vue?vue&type=template&id=b9f8033e&scoped=true&"
import script from "./GroupDropdown.vue?vue&type=script&lang=js&"
export * from "./GroupDropdown.vue?vue&type=script&lang=js&"
import style0 from "./GroupDropdown.vue?vue&type=style&index=0&id=b9f8033e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f8033e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})
